import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "cthhs",
            label: "CTH/ HSN Code",
            component: "text-field",
            width: "40%",
            type: "autocomplete",
            endpoint: "getHsnCodeMaster",
          },
          {
            name: "hscode",
            label: "HS Codes",
            component: "outlinebutton",
            width: "15%",
            sx: {
              mt: "32px",
            },
            disable: true,
          },
          {
            name: "declaration",
            label: "Declaration",
            component: "outlinebutton",
            action:"openSubDialog",
            subComponent: "ImportProductDeclaration",
            width: "15%",
            sx: {
              mt: "32px",
            },
            disable: true,
          },
          {
            name: "singlewindow",
            checkboxLabel: "Single Window Info Required",
            component: "checkboxbox",
            sx: {
              mt: "32px",
            },
          },
        ],
        row2: [
          {
            name: "ritcno",
            label: "RITC No.",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getHsnCodeMaster",
          },
          {
            name: "ritcnoratetype",
            label: "Rate Type",
            component: "dropdown",
            options: [
              { label: "Standard", value: "Standard" },
              { label: "Preferential", value: "Preferential" },
            ],
          },
        ],
        row3: [
          {
            name: "basicdutysrNo",
            label: "Basic Duty/Notn.",
            component: "text-field",
          },
          {
            name: "basicnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              basicdutysrNo: "notation",
            },
          },
          {
            name: "basicdutypercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "basicdutymethod",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",
          },
          {
            name: "basicdutyvalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "basicdutyunit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row4: [
          {
            name: "aidcsrNo",
            label: "AIDC.",
            component: "text-field",
          },
          {
            name: "aidcnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              aidcsrNo: "notation",
            },
          },
          {
            name: "aidcpercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "ate",
            actionText: "% Exemption",
            width: "72%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1,  },
          },
          {
            name: "aidcextemtion",
            component: "text-field",
            // placeholder: "0.00",
          },
          {
            name: "aidcextemtionNotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
          },
          {
            name: "aidcvalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "Miscellrate",
            actionText: "%",
            component: "typographytext",
            // width: "15%",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row5: [
          {
            name: "HealthCesssrNo",
            label: "Health Cess",
            component: "text-field",
          },
          {
            name: "HealthCesssnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              HealthCesssrNo: "notation",
            },
          },
          {
            name: "HealthCessspercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "HealthCesssrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "HealthCesssmethod",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "healthvalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "healthunit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row6: [
          {
            name: "RoadInfrasrNo",
            label: "Road & Infra. Cess",
            component: "text-field",
          },
          {
            name: "RoadInfranotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              RoadInfrasrNo: "notation",
            },
          },
          {
            name: "RoadInfrapercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "RoadInfraaneous",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "RoadInframethod",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "RoadInfravalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "RoadInfraunit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row7: [
          {
            name: "SocialWelfaresrNo",
            label: "Social Welfare Surch.",
            component: "text-field",
          },
          {
            name: "SocialWelfarenotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SocialWelfaresrNo: "notation",
            },
          },
          {
            name: "SocialWelfarepercentage",
            component: "text-field",
            dataType: "float",
            placeholder: "0.00",
          },
          {
            name: "SocialWelfareaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row8: [
          {
            name: "EducationCesssrNo",
            label: "Education Cess",
            component: "text-field",
          },
          {
            name: "EducationCessnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              EducationCesssrNo: "notation",
            },
          },
          {
            name: "EducationCesspercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "EducationCessaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row9: [
          {
            name: "SecHigherEdCesssrNo",
            label: "Sec & Higher Ed. Cess",
            component: "text-field",
          },
          {
            name: "SecHigherEdCessnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SecHigherEdCesssrNo: "notation",
            },
          },
          {
            name: "SecHigherEdCesspercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "SecHigherEdCessaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row10: [
          {
            name: "NCDsrNo",
            label: "NCD",
            component: "text-field",
          },
          {
            name: "NCDnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              NCDsrNo: "notation",
            },
          },
          {
            name: "NCDpercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "NCDrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "NCDmethod",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",
          },
          {
            name: "NCDvalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "NCDunit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "NCDsection",
            component: "dropdown",
            options: [
              { label: "U.Sec.134", value: "U.Sec.134" },
              { label: "U.Sec.136", value: "U.Sec.136" },              
            ],
            defaultValue: "U.Sec.134",
          },
        ],
        row11: [
          {
            name: "AggregateDutysrNo",
            label: "Aggregate Duty",
            component: "text-field",
          },
          {
            name: "AggregateDutynotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              AggregateDutysrNo: "notation",
            },
          },
          {
            name: "AggregateDutypercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "AggregateDutyrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row12: [
          {
            name: "SafeguardDutysrNo",
            label: "Safeguard Duty",
            component: "text-field",
          },
          {
            name: "SafeguardDutynotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SafeguardDutysrNo: "notation",
            },
          },
          {
            name: "SafeguardDutypercentage",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "SafeguardDutyrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "SafeguardDutymethod",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",
          },
          {
            name: "SafeguardDutyvalue",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "SafeguardDutyunit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row13: [
          {
            name: "SAPTANotnsrNo",
            label: "SAPTA Notn.",
            component: "text-field",
            width: "22%",
          },
          {
            name: "SAPTANotnnotn",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SAPTANotnsrNo: "notation",
            },
            width: "22%",
          },
          {
            name: "SAPTANotnpercentage",
            component: "text-field",
            placeholder: "0.00",

          },

        ],
        row14: [
          {
            name: "TariffValuresrNo",
            label: "Tariff Value",
            component: "text-field",
          },
          {
            name: "TariffValuenotn",
            component: "text-field",
          },
          {
            name: "TariffValue",
            actionText: "Qty",
            component: "typographytext",
            width: "2%",
            sx: { mt: 4   },
          },
          {
            name: "TariffValuequantity",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "TariffValuequantit21y",
            label: "Unit",
            component: "outlinebutton",
            sx: {
              mt: "32px",
            },
          },
          {
            name: "TamtfValuerate",
            actionText: "Amt",
            component: "typographytext",
            sx: { mt: 4   },
            width: "2%",

          },
          {
            name: "amountType",
            component: "text-field",
            // endpoint: "getExchange",
            // type: "autocomplete",

          },
          {
            name: "Tariff121Value",
            component: "text-field",
            placeholder: "0.00",
            dataType: "float",

          },
          {
            name: "Tarifffskffserate",
            actionText: "/",
            component: "typographytext",
            sx: { mt: 4},
            width: "1%",

          },
          {
            name: "TariffValuequantity322",
            label: "Unit",
            component: "outlinebutton",
            sx: {
              mt: "32px",
            },
          },
        ],
      },
    },
  ],
};
